import {
    ConfigurationDataResultModel,
    ConfiguratorProductModel,
    CylindoConfigModel,
    ConfiguratorItemAttributesModel,
} from "@tSurya/Store/Data/ConfiguratorModels";

export interface ConfiguratorState {
    productConfig: ConfiguratorProductModel | null;
    selections: Record<string, string>;
    valueLookup: Record<string, string>;
    configurationResult: ConfigurationDataResultModel | null;
    cylindoConfig: CylindoConfigModel | null;
    /** Cylindo features validated against the Cylindo Content API. Set by useCylindoViewerState. */
    validatedCylindoFeatures: Record<string, string> | null;
    /** Cylindo feature codes dropped during that validation because Cylindo cannot render them. */
    droppedCylindoFeatures: string[] | null;
    selectedStyleId: string | null;
    /** Per-item attribute overrides fetched once per product. */
    itemAttributes: ConfiguratorItemAttributesModel[] | null;
    /** Snapshot of the PDP product's original properties, captured before the first override merge. */
    baselineProductProperties: Record<string, string> | null;
    isUpdating: boolean;
    error: string | null;
}

export const configuratorInitialState: ConfiguratorState = {
    productConfig: null,
    selections: {},
    valueLookup: {},
    configurationResult: null,
    cylindoConfig: null,
    validatedCylindoFeatures: null,
    droppedCylindoFeatures: null,
    selectedStyleId: null,
    itemAttributes: null,
    baselineProductProperties: null,
    isUpdating: false,
    error: null,
};
